const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.js';

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$select: $('.js-select'),
	$selectProductsListing: $('.js-products-listing__holder-sort'),
	$selectSingleProduct: $('.js-single-product__upper-right-select'),
	$selectSingleProductSelects: $('.variations-options select'),
	$selectSearchResults: $('#per-page-select'),

	/** @description Initialize */
	init: function() {
		this.select2();
	},

	select2: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$select.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class'
		});
		Select2.$selectSingleProduct.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'single-product-select__dropdown',
			placeholder: 'Odaberi opciju',
			allowClear: true
		});
		Select2.$selectSingleProductSelects.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'single-product-select__dropdown-size-color',
			placeholder: 'Odaberi opciju',
			allowClear: true
		});
		Select2.$selectSearchResults.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'single-product-select__dropdown search-select',
			allowClear: true
		});
	}
};

export default Select2;
